// extracted by mini-css-extract-plugin
export default {"title":"settingssidebar_title__svGtb","linkItem":"settingssidebar_linkItem__HYJIN","active":"settingssidebar_active__2QX3S"};